export default __webpack_public_path__ + "static/Rex_Tek_Saddle-ecbcee24b7a8cd5e4bcd1646db43cf0e.png";